module.exports = __webpack_public_path__ + "static/media/Sopas Mein.64e9d057.svg";